import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { ConfirmProvider } from './contexts/ConfirmContext';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CandidateList from './pages/CandidateList';
import CandidateProfile from './pages/CandidateProfile';
import AddCandidate from './pages/AddCandidate';
import CourseOfStudy from './pages/CourseOfStudy';
import ActionReports from './pages/ActionReports';
import AdminActionReports from './pages/AdminActionReports';
import Districts from './pages/Districts';
import ImportCandidates from './pages/ImportCandidates';
import CandidateSubmission from './pages/CandidateSubmission';
import SubmissionLinks from './pages/SubmissionLinks';
import SubmissionTemplateEditorPage from './pages/SubmissionTemplateEditor';
import StatusConfiguration from './pages/StatusConfiguration';
import UserManagement from './pages/UserManagement';
import Reports from './pages/Reports';
import ActionReportSummary from './pages/ActionReportSummary';
import AnnualConferenceReport from './pages/AnnualConferenceReport';
// CRC components moved to archive - uncomment if needed
// import CRCDashboard from './pages/CRCDashboard';
// import CRCRequests from './pages/CRCRequests';
// import CRCMeetings from './pages/CRCMeetings';
import EmailTemplateSettings from './pages/EmailTemplateSettings';
import PrivateRoute from './components/PrivateRoute';
import RoleBasedRoute from './components/RoleBasedRoute';
import './styles/App.css';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <ConfirmProvider>
      <Router>
        <div className="App">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route 
                path="/dashboard" 
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/candidates" 
                element={
                  <PrivateRoute>
                    <CandidateList />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/candidates/add" 
                element={
                  <PrivateRoute>
                    <AddCandidate />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/candidates/:id" 
                element={
                  <PrivateRoute>
                    <CandidateProfile />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/course-of-study" 
                element={
                  <PrivateRoute>
                    <CourseOfStudy />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/action-reports" 
                element={
                  <PrivateRoute>
                    <ActionReports />
                  </PrivateRoute>
                } 
              />
              <Route
                path="/reports"
                element={
                  <PrivateRoute>
                    <Reports />
                  </PrivateRoute>
                }
              />
              <Route
                path="/reports/action-report-summary"
                element={
                  <PrivateRoute>
                    <ActionReportSummary />
                  </PrivateRoute>
                }
              />
              <Route
                path="/reports/annual-conference"
                element={
                  <PrivateRoute>
                    <AnnualConferenceReport />
                  </PrivateRoute>
                }
              />
              <Route 
                path="/districts" 
                element={
                  <PrivateRoute>
                    <Districts />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/candidates/import" 
                element={
                  <PrivateRoute>
                    <ImportCandidates />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/submission-links" 
                element={
                  <PrivateRoute>
                    <SubmissionLinks />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/submission-template-editor" 
                element={
                  <PrivateRoute>
                    <SubmissionTemplateEditorPage />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/status-configuration" 
                element={
                  <PrivateRoute>
                    <StatusConfiguration />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/user-management" 
                element={
                  <RoleBasedRoute allowedRoles={['Admin']}>
                    <UserManagement />
                  </RoleBasedRoute>
                } 
              />
              <Route 
                path="/email-template-settings" 
                element={
                  <RoleBasedRoute allowedRoles={['Admin']}>
                    <EmailTemplateSettings />
                  </RoleBasedRoute>
                } 
              />
              <Route 
                path="/admin/action-reports" 
                element={
                  <RoleBasedRoute allowedRoles={['Admin', 'Manager', 'BOM Registrar', 'dCOM', 'dCOM Chair']}>
                    <AdminActionReports />
                  </RoleBasedRoute>
                } 
              />
              {/* CRC Routes - Archived (uncomment if needed) */}
              {/*
              <Route 
                path="/crc" 
                element={
                  <PrivateRoute>
                    <CRCDashboard />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/crc/dashboard" 
                element={
                  <PrivateRoute>
                    <CRCDashboard />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/crc/requests" 
                element={
                  <PrivateRoute>
                    <CRCRequests />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/crc/meetings" 
                element={
                  <PrivateRoute>
                    <CRCMeetings />
                  </PrivateRoute>
                } 
              />
              */}
              {/* Public route for candidate submissions */}
              <Route 
                path="/submission/:candidateId" 
                element={<CandidateSubmission />} 
              />
            </Routes>
          </main>
        </div>
      </Router>
        </ConfirmProvider>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
